// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.miniCalendarTable_xCez7 {
	border-spacing: 0px;
	z-index: 400000;
}

.miniCalendarTbody_k_3A_ {
	gap: 0px;
}

.miniCalendarTr_OK0xw {
	position: relative !important;
	border-bottom: 2.4px solid var(--border-color);
}

.miniCalendarTr_OK0xw:last-child {
	border-bottom: none !important;
}
.miniCalendarTd_hk2rz {
	height: 48px !important;
	width: 48px !important;
	min-height: 48px !important;
	min-width: 48px !important;
	max-height: 48px !important;
	max-width: 48px !important;
	padding-left: 2px;
	position: relative;
	border: 2.4px solid var(--border-color) !important;
}
.tdLine_LhuBQ {
	position: absolute;
	left: 0;
	bottom: -1.5px;
	height: 1.5px;
	width: 100px;
	background: linear-gradient(
		to right,
		rgba(0, 0, 0, 0),
		var(--border-color) 20%,
		var(--border-color) 80%,
		var(--border-color) 100%
	);
}
.tdLineEnd_XIEmZ {
	position: absolute;
	right: 0;
	bottom: -1.5px;
	height: 1.5px;
	width: 100px;
	background: linear-gradient(
		to left,
		rgba(0, 0, 0, 0),
		var(--border-color) 20%,
		var(--border-color) 80%,
		var(--border-color) 100%
	);
}

.miniCalendarTd_hk2rz:first-child {
	border: 2.4px solid transparent !important;
	border-right: 2.4px solid var(--border-color) !important;
}
.miniCalendarTd_hk2rz:last-child {
	border: 2.4px solid transparent !important;
	border-left: 2.4px solid var(--border-color) !important;
}
.bottomMiniCalendarTd__oevw {
	position: relative;
	border: none !important;
	border-right: 2.4px solid transparent !important;
	border-left: 2.4px solid transparent !important;
}

.bottomLine_vVZAy {
	height: 100px;
	position: absolute;
	bottom: 0;
	width: 1.5px !important;
	min-width: 1.5px;
	z-index: 100000;
	height: 100px;
	right: -1.5px;
	background: linear-gradient(
		to top,
		rgba(0, 0, 0, 0),
		var(--border-color) 20%,
		var(--border-color) 80%,
		var(--border-color) 100%
	);
}
.bottomMiniCalendarTd__oevw:nth-child(5) .bottomLine_vVZAy {
	width: 2px !important;
	min-width: 2px !important;
	right: -2px;
}
.topLine_qAOT5 {
	height: 100px;
	position: absolute;
	top: 0;
	width: 1.5px !important;
	min-width: 1.5px !important;
	z-index: 100000;
	height: 100px;
	right: -0.5px;
	background: linear-gradient(
		to bottom,
		rgba(0, 0, 0, 0),
		var(--border-color) 20%,
		var(--border-color) 80%,
		var(--border-color) 100%
	);
	z-index: 900000;
}
.miniCalendarTh_NiXhX:nth-child(3) .topLine_qAOT5 {
	width: 2px !important;
	min-width: 2px !important;
	right: -1px;
}
.miniCalendarTh_NiXhX:nth-child(5) .topLine_qAOT5 {
	width: 2px !important;
	min-width: 2px !important;
	right: -1px;
}
.bottomMiniCalendarTd__oevw:first-child {
	border-left: none !important;
}
.bottomMiniCalendarTd__oevw:last-child {
	border-right: none !important;
}
.miniCalendarTh_NiXhX {
	position: relative;
	border-bottom: 2.4px solid var(--border-color);
	border-top: none;
	font-size: 18px !important;
}
.miniCalendarTh_NiXhX:first-child {
	border-left: none;
	border-bottom: none !important;
}
.miniCalendarTh_NiXhX:last-child {
	border-right: none;
	border-bottom: none !important;
}
.dayCell_DWirH {
	border-radius: 50%;
	color: var(--_3c3a3a-color);
	cursor: pointer;
	width: 30px !important;
	height: 30px !important;
	-webkit-user-select: none;
	        user-select: none;
	min-width: 30px !important;
	min-height: 30px !important;
	padding: 3.6px !important;
	display: flex;
	align-items: center;
	margin-left: 6px;
	justify-content: center;
	font-size: 14.4px;
	&:hover {
		background: var(--label-color);
	}
}

.selectedDayCell_gIg18 {
	background: var(--_16c0982e-background);
	border-radius: 50%;
	cursor: pointer;
	color: var(--_16c098-background);
	width: 30px !important;
	height: 30px !important;
	min-width: 30px !important;
	min-height: 30px !important;
	padding: 3.6px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14.4px;
	&:hover {
		background: var(--_16c098-color);
	}
}

.currentDayCell_qyKY_ {
	background: var(--_16c098-background);
	border-radius: 50%;
	color: var(--white-color);
	cursor: pointer;
	width: 30px !important;
	height: 30px !important;
	min-width: 30px !important;
	min-height: 30px !important;
	padding: 3.6px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14.4px;
	&:hover {
		background: var(--_16c098-background);
	}
}
.eventDotsContainer_WYp8T {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: row;
	position: absolute;
	top: 1.2px;
	right: 1.2px;
}
.eventDot_a1vOV {
	width: 10.8px;
	margin-left: -3.24px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 1.08px;
	font-size: 7.56px;
	color: var(--white-color);
	height: 10.8px;
	border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/AppointmentCalendar.module.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,6BAA6B;CAC7B,8CAA8C;AAC/C;;AAEA;CACC,8BAA8B;AAC/B;AACA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,2BAA2B;CAC3B,0BAA0B;CAC1B,2BAA2B;CAC3B,0BAA0B;CAC1B,iBAAiB;CACjB,kBAAkB;CAClB,kDAAkD;AACnD;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,cAAc;CACd,aAAa;CACb,YAAY;CACZ;;;;;;EAMC;AACF;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,cAAc;CACd,aAAa;CACb,YAAY;CACZ;;;;;;EAMC;AACF;;AAEA;CACC,0CAA0C;CAC1C,wDAAwD;AACzD;AACA;CACC,0CAA0C;CAC1C,uDAAuD;AACxD;AACA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,gDAAgD;CAChD,+CAA+C;AAChD;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,SAAS;CACT,uBAAuB;CACvB,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb,aAAa;CACb;;;;;;EAMC;AACF;AACA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,MAAM;CACN,uBAAuB;CACvB,2BAA2B;CAC3B,eAAe;CACf,aAAa;CACb,aAAa;CACb;;;;;;EAMC;CACD,eAAe;AAChB;AACA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,kBAAkB;CAClB,8CAA8C;CAC9C,gBAAgB;CAChB,0BAA0B;AAC3B;AACA;CACC,iBAAiB;CACjB,8BAA8B;AAC/B;AACA;CACC,kBAAkB;CAClB,8BAA8B;AAC/B;AACA;CACC,kBAAkB;CAClB,2BAA2B;CAC3B,eAAe;CACf,sBAAsB;CACtB,uBAAuB;CACvB,yBAAiB;SAAjB,iBAAiB;CACjB,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,iBAAiB;CACjB;EACC,8BAA8B;CAC/B;AACD;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,eAAe;CACf,gCAAgC;CAChC,sBAAsB;CACtB,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB;EACC,gCAAgC;CACjC;AACD;;AAEA;CACC,qCAAqC;CACrC,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,sBAAsB;CACtB,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB;EACC,qCAAqC;CACtC;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;CACV,YAAY;AACb;AACA;CACC,aAAa;CACb,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;CACnB,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;CACd,kBAAkB;AACnB","sourcesContent":[".miniCalendarTable {\n\tborder-spacing: 0px;\n\tz-index: 400000;\n}\n\n.miniCalendarTbody {\n\tgap: 0px;\n}\n\n.miniCalendarTr {\n\tposition: relative !important;\n\tborder-bottom: 2.4px solid var(--border-color);\n}\n\n.miniCalendarTr:last-child {\n\tborder-bottom: none !important;\n}\n.miniCalendarTd {\n\theight: 48px !important;\n\twidth: 48px !important;\n\tmin-height: 48px !important;\n\tmin-width: 48px !important;\n\tmax-height: 48px !important;\n\tmax-width: 48px !important;\n\tpadding-left: 2px;\n\tposition: relative;\n\tborder: 2.4px solid var(--border-color) !important;\n}\n.tdLine {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: -1.5px;\n\theight: 1.5px;\n\twidth: 100px;\n\tbackground: linear-gradient(\n\t\tto right,\n\t\trgba(0, 0, 0, 0),\n\t\tvar(--border-color) 20%,\n\t\tvar(--border-color) 80%,\n\t\tvar(--border-color) 100%\n\t);\n}\n.tdLineEnd {\n\tposition: absolute;\n\tright: 0;\n\tbottom: -1.5px;\n\theight: 1.5px;\n\twidth: 100px;\n\tbackground: linear-gradient(\n\t\tto left,\n\t\trgba(0, 0, 0, 0),\n\t\tvar(--border-color) 20%,\n\t\tvar(--border-color) 80%,\n\t\tvar(--border-color) 100%\n\t);\n}\n\n.miniCalendarTd:first-child {\n\tborder: 2.4px solid transparent !important;\n\tborder-right: 2.4px solid var(--border-color) !important;\n}\n.miniCalendarTd:last-child {\n\tborder: 2.4px solid transparent !important;\n\tborder-left: 2.4px solid var(--border-color) !important;\n}\n.bottomMiniCalendarTd {\n\tposition: relative;\n\tborder: none !important;\n\tborder-right: 2.4px solid transparent !important;\n\tborder-left: 2.4px solid transparent !important;\n}\n\n.bottomLine {\n\theight: 100px;\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 1.5px !important;\n\tmin-width: 1.5px;\n\tz-index: 100000;\n\theight: 100px;\n\tright: -1.5px;\n\tbackground: linear-gradient(\n\t\tto top,\n\t\trgba(0, 0, 0, 0),\n\t\tvar(--border-color) 20%,\n\t\tvar(--border-color) 80%,\n\t\tvar(--border-color) 100%\n\t);\n}\n.bottomMiniCalendarTd:nth-child(5) .bottomLine {\n\twidth: 2px !important;\n\tmin-width: 2px !important;\n\tright: -2px;\n}\n.topLine {\n\theight: 100px;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 1.5px !important;\n\tmin-width: 1.5px !important;\n\tz-index: 100000;\n\theight: 100px;\n\tright: -0.5px;\n\tbackground: linear-gradient(\n\t\tto bottom,\n\t\trgba(0, 0, 0, 0),\n\t\tvar(--border-color) 20%,\n\t\tvar(--border-color) 80%,\n\t\tvar(--border-color) 100%\n\t);\n\tz-index: 900000;\n}\n.miniCalendarTh:nth-child(3) .topLine {\n\twidth: 2px !important;\n\tmin-width: 2px !important;\n\tright: -1px;\n}\n.miniCalendarTh:nth-child(5) .topLine {\n\twidth: 2px !important;\n\tmin-width: 2px !important;\n\tright: -1px;\n}\n.bottomMiniCalendarTd:first-child {\n\tborder-left: none !important;\n}\n.bottomMiniCalendarTd:last-child {\n\tborder-right: none !important;\n}\n.miniCalendarTh {\n\tposition: relative;\n\tborder-bottom: 2.4px solid var(--border-color);\n\tborder-top: none;\n\tfont-size: 18px !important;\n}\n.miniCalendarTh:first-child {\n\tborder-left: none;\n\tborder-bottom: none !important;\n}\n.miniCalendarTh:last-child {\n\tborder-right: none;\n\tborder-bottom: none !important;\n}\n.dayCell {\n\tborder-radius: 50%;\n\tcolor: var(--_3c3a3a-color);\n\tcursor: pointer;\n\twidth: 30px !important;\n\theight: 30px !important;\n\tuser-select: none;\n\tmin-width: 30px !important;\n\tmin-height: 30px !important;\n\tpadding: 3.6px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: 6px;\n\tjustify-content: center;\n\tfont-size: 14.4px;\n\t&:hover {\n\t\tbackground: var(--label-color);\n\t}\n}\n\n.selectedDayCell {\n\tbackground: var(--_16c0982e-background);\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tcolor: var(--_16c098-background);\n\twidth: 30px !important;\n\theight: 30px !important;\n\tmin-width: 30px !important;\n\tmin-height: 30px !important;\n\tpadding: 3.6px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14.4px;\n\t&:hover {\n\t\tbackground: var(--_16c098-color);\n\t}\n}\n\n.currentDayCell {\n\tbackground: var(--_16c098-background);\n\tborder-radius: 50%;\n\tcolor: var(--white-color);\n\tcursor: pointer;\n\twidth: 30px !important;\n\theight: 30px !important;\n\tmin-width: 30px !important;\n\tmin-height: 30px !important;\n\tpadding: 3.6px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14.4px;\n\t&:hover {\n\t\tbackground: var(--_16c098-background);\n\t}\n}\n.eventDotsContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n\tposition: absolute;\n\ttop: 1.2px;\n\tright: 1.2px;\n}\n.eventDot {\n\twidth: 10.8px;\n\tmargin-left: -3.24px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding-top: 1.08px;\n\tfont-size: 7.56px;\n\tcolor: var(--white-color);\n\theight: 10.8px;\n\tborder-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"miniCalendarTable": `miniCalendarTable_xCez7`,
	"miniCalendarTbody": `miniCalendarTbody_k_3A_`,
	"miniCalendarTr": `miniCalendarTr_OK0xw`,
	"miniCalendarTd": `miniCalendarTd_hk2rz`,
	"tdLine": `tdLine_LhuBQ`,
	"tdLineEnd": `tdLineEnd_XIEmZ`,
	"bottomMiniCalendarTd": `bottomMiniCalendarTd__oevw`,
	"bottomLine": `bottomLine_vVZAy`,
	"topLine": `topLine_qAOT5`,
	"miniCalendarTh": `miniCalendarTh_NiXhX`,
	"dayCell": `dayCell_DWirH`,
	"selectedDayCell": `selectedDayCell_gIg18`,
	"currentDayCell": `currentDayCell_qyKY_`,
	"eventDotsContainer": `eventDotsContainer_WYp8T`,
	"eventDot": `eventDot_a1vOV`
};
export default ___CSS_LOADER_EXPORT___;
